import { MonthSwitcher, useActiveDate } from '@goodlok/react-sdk'
import { FunctionComponent, useMemo } from 'react'
import styles from './AdminHeadMonth.module.sass'

export const AdminHeadMonth: FunctionComponent = () => {
	const { activeDate, setActiveDate, resetActiveDate } = useActiveDate()

	const monthIndex = useMemo(() => activeDate.month, [activeDate])

	return (
		<div className={styles.wrapper}>
			<MonthSwitcher
				activeMonthIndex={monthIndex}
				onPreviousClick={() => {
					const newMonth = (12 + activeDate.month - 1) % 12
					const newYear = activeDate.month - 1 < 0 ? activeDate.year - 1 : activeDate.year
					setActiveDate({ year: newYear, month: newMonth })
				}}
				onNextClick={() => {
					const newMonth = (activeDate.month + 1) % 12
					const newYear = activeDate.month + 1 >= 12 ? activeDate.year + 1 : activeDate.year
					setActiveDate({ year: newYear, month: newMonth })
				}}
				onReset={() => {
					resetActiveDate()
				}}
				showTodayButton
			/>
		</div>
	)
}
